<template>
  <div class="main-body">
    <div class="header">问卷调查记录</div>
    <div class="out">

      <div class="search2">

        <div style="float:right">

          <el-select v-model="practiceSiteCode" filterable style="width:200px;margin-right: 10px;" placeholder="请选择实践站点">
            <el-option
                v-for="item in nameList"
                :key="item.practiceSiteCode"
                :label="item.name"
                :value="item.practiceSiteCode">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left">


              <el-form-item v-for="(value,i) in props.row.listAskAnswerSite" :key="i" >
                时间：{{timefilter2(value.createTime)}}
                次序：{{value.sort}}
                <span style="color:blue;margin-left: 10px;cursor: pointer;" @click="handleViewSub(value.askAnswerRecordSiteCode)">查看</span>
              </el-form-item>

            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="问卷调查名称"></el-table-column>

        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>

        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleView(scope.row.askAnswerRecordCode)">查看</el-button>
            <el-button size="mini" @click="handleViewCharts(scope.row.askAnswerRecordCode)">查看图表</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <TotalAll ref="myTotalAll" v-show="showModalAll" v-on:closeAll="closeAll" ></TotalAll>
    <TotalSub ref="myTotalSub" v-show="showModalSub" v-on:closeSub="closeSub" ></TotalSub>
    <TotalAllCharts ref="myTotalAllCharts" v-show="showModalAllCharts" v-on:closeAllCharts="closeAllCharts"></TotalAllCharts>

  </div>
</template>

<script>

import TotalAll from "./TotalAll";
import TotalSub from "./TotalSub";
import TotalAllCharts from "./TotalAllCharts";

import {timefilters, timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  data(){
    return{

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,


      nameList:[],
      practiceSiteCode:'',

      showModalAll:false,
      showModalSub:false,

      roleList:null,
      editStaff:null,

      th:0,


      showModalAllCharts:false

    }
  },
  created(){
    this.getNameList();
    this.th = this.$store.state.tableHeight;
  },
  components:{
    TotalAll,TotalSub,TotalAllCharts
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    timefilter2(cellValue){
      return timefilters(cellValue)
    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    closeAll:function(){
      this.showModalAll = !this.showModalAll;
    },

    closeSub:function(){
      this.showModalSub = !this.showModalSub;
    },

    closeAllCharts:function(){
      this.showModalAllCharts=!this.showModalAllCharts;
    },

    search(){
      this.currentPage = 1;
      this.getList();
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'AskAnswerRecord/Page',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          practiceSiteCode:this.practiceSiteCode,
        }
      }).then( (response)=> {
        console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },



    handleView(askAnswerRecordCode) {
      console.log(askAnswerRecordCode);

      this.$refs.myTotalAll.init(askAnswerRecordCode);
      this.showModalAll = !this.showModalAll;
    },
    handleViewSub(askAnswerRecordSiteCode) {
      console.log(askAnswerRecordSiteCode);

      this.$refs.myTotalSub.init(askAnswerRecordSiteCode);
      this.showModalSub = !this.showModalSu ;
    },

    handleViewCharts(askAnswerRecordCode){
      this.$refs.myTotalAllCharts.init(askAnswerRecordCode);
      this.showModalAllCharts = !this.showModalAllCharts;
    },


    getNameList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'PracticeSite/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.nameList = response.data.data.list;
          if(this.nameList.length>0){
            this.practiceSiteCode = this.nameList[0].practiceSiteCode;
            this.getList();
          }

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

<style lang="scss" scoped>

</style>
